import { mapDTO } from '@twistezo/ts-dto-mapper'

import { SelectOption } from 'components/Select'
import { DomainSlice } from '../types'
import { DomainSliceDTO } from './types'

type From = DomainSliceDTO
type To = SelectOption<DomainSlice>

export const domainFromDTO = (from: From): To =>
  mapDTO<From, To>({ from }).transform(
    ({ activeAbTest, id, name }: From): To => ({
      label: name,
      rawData: {
        activeAbTest: activeAbTest ? { id: activeAbTest.id } : undefined,
        id: id,
        name: name,
      },
      value: id,
    }),
  )
